import styled, {css} from 'styled-components'
import {ModalBody, ModalHeader} from '@components/ui/modal-atoms/ModalAtoms.tsx'

export const StyledModalHeader = styled(ModalHeader)(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 2}px;
    `
)

export const StyledVerificationModalBody = styled(ModalBody)(
    ({theme: {typography, palette}}) => css`
        ${typography.textSm};
        color: ${palette.neutral['600']};
        & b {
            color: ${palette.neutral['950']};
        }
    `
)
